import {CustomInputGeometriaValue} from "../types";
import {MessageDescriptor} from "react-intl";
import React from "react";

export const NORMATIVA_OPTIONS: {[key: string]: string} = {
  ntc2018: "NTC 2018",
  ec8: "EC8 [4.3.5.2]",
}

export const MURATURA_OPTIONS: {[key: string]: {
  f: Record<"high" | "other", number> | string,  // high/other refers to Fc value: high <- 1.35, other <- 1|1.2
  w: number | string,
  label?: string
}} = {
  "Muratura di mattoni pieni e malta di calce": {
    f: {
      high: -1.3,
      other: -1.725,
    },
    w: 18,
  },
  "Muratura di mattoni semipieni con malta cementizia": {
    f: {
      high: -2.5,
      other: -3.25,
    },
    w: 15,
  },
  "Muratura a blocchi lapidei squadrati": {
    f: {
      high: -2.9,
      other: -3.5,
    },
    w: 22,
  },
  "Muratura regolare di pietra tenera": {
    label: "Muratura regolare di pietra tenera (tufo, calcarenite)",
    f: {
      high: -1,
      other: -1.3,
    },
    w: 16,
  },
  "Muratura irregolare di pietra tenera": {
    label: "Muratura irregolare di pietra tenera (tufo, calcarenite)",
    f: {
      high: -0.7,
      other: -0.9,
    },
    w: 16,
  },
  "Muratura in pietra a spacco con buona tessitura": {
    label: "Muratura in pietra a spacco con buona tessitura",
    f: {
      high: -1.3,
      other: -1.6,
    },
    w: 21,
  },
  "Muratura a conci sbozzati": {
    f: {
      high: -1,
      other: -1,
    },
    w: 20,
  },
  "Muratura in pietrame disordinata": {
    f: {
      high: -0.5,
      other: -0.75,
    },
    w: 19,
  },
  "Altra tipologia": {
    f: "",
    w: "",
  },
}

export const FC_OPTIONS = [1, 1.2, 1.35];

export const FIELDS: {
  [key: string]: {
    required: boolean,
    numeric: boolean,
    localization?: MessageDescriptor,
    symbol?: string | React.ReactNode,
    mu?: string | React.ReactNode,
    options?: {[key: string]: string},
  }
} = {
  normativa: {required: true, numeric: false, localization: {id: "normativa_geometria_connettori", defaultMessage: "Normativa di riferimento per le azioni di carico"}, options: NORMATIVA_OPTIONS},
  type: {
    required: true,
    numeric: false,
    localization: {id: "tipologia_di_muratura", defaultMessage: "Tipologia di muratura"},
    options: Object.keys(MURATURA_OPTIONS).reduce(
      (acc, k) => ({...acc, [k]: MURATURA_OPTIONS[k].label || k}),
      {}
    ),
  },
  resistance: {required: true, numeric: true, localization: {id: "resistenza_a_compressione", defaultMessage: "Resistenza a compressione"}},
  confidence: {required: true, numeric: true, localization: {id: "fattore_di_confidenza", defaultMessage: "Fattore di confidenza"}},
  security: {required: true, numeric: true, localization: {id: "coefficiente_di_sicurezza", defaultMessage: "Coefficiente di sicurezza"}},
  specificWeight: {required: true, numeric: true, localization: {id: "peso_specifico", defaultMessage: "Peso specifico"}},
  Le: {required: true, numeric: true, mu: "m", symbol: <>L<sub>a</sub></>},
  B: {required: true, numeric: true, mu: "m", symbol: "B"},
  Bm3: {required: true, numeric: true, mu: "m", symbol: <>Bm<sub>3</sub></>},
  Bm4: {required: true, numeric: true, mu: "m", symbol: <>Bm<sub>4</sub></>},
  S1: {required: true, numeric: true, mu: "m", symbol: <>S<sub>1</sub></>},
  S2: {required: true, numeric: true, mu: "m", symbol: <>S<sub>2</sub></>},
  S3: {required: true, numeric: true, mu: "m", symbol: <>S<sub>3</sub></>},
  S4: {required: true, numeric: true, mu: "m", symbol: <>S<sub>4</sub></>},
  Hup: {required: true, numeric: true, mu: "m", symbol: <>H<sub>up</sub></>},
  Hbottom: {required: true, numeric: true, mu: "m", symbol: <>H<sub>bottom</sub></>},
  Hcordolo: {required: true, numeric: true, mu: "m", symbol: <>H<sub>cordolo</sub></>},
}

export const VALIDATE = (value?: CustomInputGeometriaValue) =>
  !!value
  && Object.keys(FIELDS).every((k) => !!(value as unknown as Record<string, any>)[k]);  // all fields are required